(function (global, factory) {
    if (!global) {
        throw new Error("main.js Requires window or a global object");
    }

    var document = global.document,
        jquery = global.jQuery;

    if (!document) {
        throw new Error("main.js requires a window or global object with a document");
    }

    if (!jquery) {
        throw new Error("main.js requires a jQuery, it miss in  window or global object");
    }

    factory(jquery, global, document);
    // Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this,
    function ($, window, document, undefined) {

        function AeForm() {

            var formAction = "https://landingreceiver.youandemili.com/api/v1/landing/process/json";
            var gdprFormDescriptor = "https://landingreceiver.youandemili.com/api/v1/integrations/cnhgpdr/config";
            var errorMessageEmail = globalVariables.errorMsgEmail;
            var errorMessagePhone = globalVariables.errorMsgPhone;
            var genericError = globalVariables.errorMsgGeneric;
            var successTitle = globalVariables.successTitle;
            var successMessage = globalVariables.successMessage;

            $(document).ready(function () {



                jQuery.validator.addMethod("notNumber", function (value, element, param) {
                    var reg = /[0-9]/;
                    if (reg.test(value)) {
                        return false;
                    } else {
                        return true;
                    }
                }, "Numbers not allowed");

                $("#phonenumber").keypress(function (e) {
                    if (String.fromCharCode(e.which).match(/[^+0-9]/)) {
                        e.preventDefault();
                    }
                });

                $("#city").keypress(function (e) {
                    e = e || window.event;
                    var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
                    var charStr = String.fromCharCode(charCode);
                    if (/\d/.test(charStr)) {
                        e.preventDefault();
                    }
                });

                $("#postalcode").attr("maxlength", 10);


                /*** select floating label ***/
                $(".ae-form-select").each(function () {
                    selectLabel($(this));
                });

                $(".ae-form-select").on("change", function () {
                    selectLabel($(this));
                });

                $("#country").on("change", function () {
                    $("#countryname").val($("#country option:selected").text());
                });

                $("#purchaseIntention").on("change", function () {
                    $("#purchaseIntentionText").val($("#purchaseIntention option:selected").text());
                });

                $("#model").on("change", function () {
                    $("#modelText").val($("#model option:selected").text());
                });


                //validate form
                $("#landing-form").validate({
                    errorElement: "span",
                    rules: {
                        city: 'notNumber'
                    }
                });

                if (globalVariables.lang == "pl") {
                    console.log("PL -> GDPR");
                    $("#form-submit").removeAttr("disabled");
                } else {
                    console.log("OTHER -> GDPR");
                    /** GDPR **/
                    GetFormDescriptor();
                }

                configLandigReceiver();
            });

            function configLandigReceiver() {
                //campaign tracking
                var gtmref = getUrlParameter("utm_source");
                var gtmcampaign = getUrlParameter("utm_campaign");
                var gtmmedium = getUrlParameter("utm_medium");
                var gtmcontent = getUrlParameter("utm_content");
                var placement = getUrlParameter("placement");
                var adset = getUrlParameter("adset");
                var campaignname = getUrlParameter("campaign_name");

                if (gtmref != undefined) {
                    $("#gtmref").val(gtmref);
                }
                if (gtmcampaign != undefined) {
                    $("#gtmcampaign").val(gtmcampaign);
                }

                if (gtmmedium != undefined) {
                    $("#gtmmedium").val(gtmmedium);
                }

                if (gtmcontent != undefined) {
                    $("#gtmcontent").val(gtmcontent);
                }

                if (placement != undefined) {
                    $("#placement").val(placement);
                }

                if (adset != undefined) {
                    $("#adset").val(adset);
                }

                if (campaignname != undefined) {
                    $("#campaignname").val(campaignname);
                }

                //final form post
                $("#landing-form").submit(function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    var form = $("#landing-form");


                    if (globalVariables.lang == "pl") {
                        $("#gdpr-contact-error").hide();
                        $("#gdpr_email").removeClass("error");
                        $("#gdpr_phone").removeClass("error");
                        $("#gdpr_sms").removeClass("error");

                        var gdpr_email = $("#gdpr_email").is(":checked");
                        var gdpr_phone = $("#gdpr_phone").is(":checked");
                        var gdpr_sms = $("#gdpr_sms").is(":checked");
                        console.log("gdpr_email", gdpr_email);
                        console.log("gdpr_phone", gdpr_phone);
                        console.log("gdpr_sms", gdpr_sms);
                        if (!gdpr_email && !gdpr_phone && !gdpr_sms) {
                            console.log("all false");
                            $("#gdpr_email").addClass("error");
                            $("#gdpr_phone").addClass("error");
                            $("#gdpr_sms").addClass("error");
                            $("#gdpr-contact-error").show();
                            return;
                        }

                        if (gdpr_email) {
                            $("#contact_email").val("1");
                        } else {
                            $("#contact_email").val("0");
                        }

                        if (gdpr_phone) {
                            $("#contact_phone").val("1")
                        } else {
                            $("#contact_phone").val("0"); 
                        }

                        if (gdpr_sms) {
                            $("#contact_sms").val("1");
                        } else {
                            $("#contact_sms").val("0");
                        }
                    } else {
                        var gdprMarketing = $("input[name=gdpr_1]:checked").val();
                        var gdprMarketingThird = $("input[name=gdpr_2]:checked").val();
                        console.log("gdprMarketing", gdprMarketing);
                        console.log("gdprMarketingThird", gdprMarketingThird);
                        if (gdprMarketing === "1" || gdprMarketingThird === "1") {
                            $("#contact_email").val("1");
                            $("#contact_phone").val("1");
                            $("#contact_sms").val("1");
                        } else {
                            $("#contact_email").val("0");
                            $("#contact_phone").val("0");
                            $("#contact_sms").val("0");
                        }
                    }


                    if (form.valid()) {
                        $("#form-submit").attr("disabled", "disabled");
                        $("#waiting-form").removeClass("d-none");

                        postData(form);
                    }
                    return false;
                });
            }

            function postData(form) {
                var formData = form.serializeArray();

                var jsonData = {
                    "url": window.location.href,
                    "name": $("#landingName").val(),
                    "id": $("#lid").val(),
                    "data": objectifyForm(formData)
                };

                //console.log(jsonData);

                //post
                $.ajax({
                    async: true,
                    type: "POST",
                    beforeSend: function (request) {
                        request.setRequestHeader("X-LID", $("#lid").val());
                    },
                    url: formAction,
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(jsonData),
                    success: function (resp) {
                        //console.log(resp);
                        var obj = JSON.parse(JSON.stringify(resp));
                        if (obj.status === 1) {
                            try {

                                //Tracciamento del form inviato
                                /**** GTM Navigation Event ****/
                                if (typeof dataLayer !== "undefined") {

                                    dataLayer.push({
                                        "event": "Pageview",
                                        "pagePath": location.pathname.replace("index.html", "") + "/form-send/",
                                        "pageTitle": "Forn send | " + $(document).find("title").text()
                                    });
                                }

                                showSuccess()
                                document.getElementById("landing-form").reset();
                            } catch (err) {
                                console.log(err)
                                showError(genericError);
                            }

                            $("#form-submit").removeAttr("disabled");
                            $("#waiting-form").addClass("d-none");

                        } else {

                        }
                    },
                    error: function (err) {
                        var obj = JSON.parse(JSON.stringify(err));
                        //console.log("ERR");
                        //console.log(obj);
                        if (obj.status === 400) {
                            var objResp = JSON.parse(JSON.stringify(obj.responseJSON));
                            console.log(obj.responseJSON);
                            if (objResp.status === 3) {
                                var em = "";
                                //console.log(objResp.validationErrors);
                                $.each(objResp.validationErrors, function (k, er) {
                                    if (er["fieldName"] == "phonenumber") {
                                        em = em + errorMessagePhone + "<br />";
                                    }
                                    if (er["fieldName"] == "email") {
                                        em = em + errorMessageEmail + "<br />";
                                    }
                                });
                                if (em.length == 0) {
                                    em = genericError;
                                }
                                showError(em);
                            } else
                            if (objResp.status === 4) {
                                //email esistente
                                showError(userExistError);
                            } else {
                                showError(genericError);
                            }
                        }
                        $("#form-submit").removeAttr("disabled");
                        $("#waiting-form").addClass("d-none");
                    }
                });

            }


            function selectLabel(s) {
                var lbl = $("label[for='" + s.attr("id") + "']");
                if (s.val() == "") {
                    lbl.addClass("d-none");
                    s.addClass("normal");
                    s.removeClass("ae-selected")
                } else {
                    lbl.removeClass("d-none");
                    s.removeClass("normal");
                    s.addClass("ae-selected")
                }
            }

            function getUrlParameter(sParam) {

                var sPageURL = decodeURIComponent(window.location.href.substring(window.location.href.indexOf("?") + 1)),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;
                for (i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');

                    if (sParameterName[0] === sParam) {
                        return sParameterName[1] === undefined ? true : sParameterName[1];
                    }
                }
            };

            //create json from form data
            function objectifyForm(formArray) {

                var returnArray = {};
                for (var i = 0; i < formArray.length; i++) {
                    returnArray[formArray[i]['name']] = formArray[i]['value'];
                }
                return returnArray;
            }

            function showError(err) {
                bootbox.alert({
                    centerVertical: true,
                    message: '<h5 class="text-danger text-uppercase"></h5><div class="text-danger">' + err + '</div>'
                });
            }

            function showSuccess() {
                bootbox.alert({
                        centerVertical: true,
                        message: '<div id="form-success"><h5 class="text-uppercase ae-lid-form-success">' + successTitle + '</h5><div>' + successMessage + '</div></div>',
                    }

                );
            }


            /**** GDPR ****/

            function GetFormDescriptor() {
                $.ajax({
                    async: true,
                    type: "GET",
                    beforeSend: function (request) {
                        request.setRequestHeader("X-LID", $("#lid").val());
                    },
                    url: gdprFormDescriptor,
                    success: function (resp) {
                        if (resp != null) {
                            $("#gdpr").val(JSON.stringify(resp));
                            GenerateFields(resp);
                            $("#form-submit").removeAttr("disabled");
                            // setInfoSectionPosition();
                        }
                    },
                    error: function (resp) {
                        //console.log(resp)

                    }

                });
            }

            function GenerateFields(x) {
                $.each(x, function (key, val) {
                    if (key === "policies") {
                        $.each(val, function (index, value) {
                            if (value.type === "checkbox") {
                                GenerateChecbox(value)
                            }

                            if (value.type === "radio") {
                                GenerateRadio(value)
                            }

                        });
                    }
                });
            }

            function GenerateChecbox(policy) {
                var html =
                    '<div class="form-group form-check">' +
                    '<input type="checkbox" class="form-check-input gdpr-checkbox" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '" value="1" ' + (policy.required ? "required" : "") + ' />' +
                    '<label class="gdpr-policy-label form-check-label" for="gdpr_' + policy.id + '">' + policy.description + ' *</label>' +
                    '</div>' +
                    '</div>';

                var old = $("#gdpr-block").html();
                $("#gdpr-block").html(old + html);

            }

            function GenerateRadio(policy) {
                var html = ' <div class="form-group"> ' +
                    '<div><div class="gdpr-scrollable">' +
                    policy.title + " *<br />" + policy.description +
                    '<br />' +
                    '</div>' +
                    '<div class="form-check form-check-inline">' +
                    '<input class="form-check-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-0" value="1" required />' +
                    '<label class="form-check-label" for="gdpr_' + policy.id + '-0">' + policy.accept_label + '</label>' +
                    '</div>' +
                    '<div class="form-check form-check-inline">' +
                    '<input class="form-check-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-1" value="0" /> ' +
                    '<label class="form-check-label" for="gdpr_' + policy.id + '-1">' + policy.deny_label + '</label>' +
                    '</div>' +
                    '</div></div>'

                var old = $("#gdpr-block").html();
                $("#gdpr-block").html(old + html);
            }
        }

        if (!window.aeForm) {
            window.aeForm = new AeForm();
        } else {
            console.warn("aeForm already exist in the global object.");
        }
    }));